import { Avatar } from "@heroui/react";
import TransferCardElement from "../../assets/transfer-card-element.svg?react";

export function TransferCard({
  tokenSymbol,
  displayAmount,
  senderAddress,
  recipientAddress,
}: {
  tokenSymbol: string;
  displayAmount: number;
  senderAddress: string;
  recipientAddress: string;
}) {
  // TODO: get token address as a prop
  // Derive the token symbol from the token address
  // TODO: get amount as bigint
  // TODO: fetch token decimals from the token address
  // derive the display amount from the amount and token decimals
  return (
    <div className="grid *:col-start-1 *:row-start-1 w-full">
      <TransferCardElement className="w-full" />
      <div className="flex items-center w-full">
        <div className="flex flex-col items-center flex-1">
          <Avatar name="T" color="primary" className="size-10 mb-2" />
          <span className="font-semibold">{senderAddress}</span>
          <span className="text-small text-[#ADC0D0]">
            -{displayAmount} {tokenSymbol}
          </span>
        </div>
        <div className="basis-10" />
        <div className="flex flex-col items-center flex-1">
          <Avatar name="T" color="primary" className="size-10 mb-2" />
          <span className="font-semibold">{recipientAddress}</span>
          <span className="text-small text-[#ADC0D0]">
            +{displayAmount} {tokenSymbol}
          </span>
        </div>
      </div>
    </div>
  );
}
